import { useCssModule, ref, computed } from "vue";
import "./assets/index-CgZzOVq6.js";
import { u as useListeners } from "./assets/index-Ca8wHgNc.js";
import { u as useDataTestIdProp } from "./assets/index-BNd8MWnO.js";
import "./assets/index-vzP2cezV.js";
import "vue-demi";
import "vue-router";
import "dompurify";
import "@vueuse/core";
import { S as SingleInput, e as emits, t as types, b as baseProps, g as getItemsWithDefaultKeys, c as changeEvent } from "./assets/SingleInput-CTOYPcHF.js";
import { n as normalizeComponent } from "./assets/_plugin-vue2_normalizer-VvYS6rEj.js";
import "vue-i18n";
import "./locales.js";
import "./assets/index-Df_FM1j-.js";
import "./assets/index-BJV0_gaH.js";
import "./assets/index-DKxr0Yto.js";
const BaseOptionFieldset = "_BaseOptionFieldset_dfstq_1";
const container = "_container_dfstq_9";
const isDirectionRow = "_isDirectionRow_dfstq_14";
const BaseOptionFieldsetLegend = "_BaseOptionFieldsetLegend_dfstq_18";
const isEmpty = "_isEmpty_dfstq_24";
const style0 = {
  BaseOptionFieldset,
  container,
  isDirectionRow,
  BaseOptionFieldsetLegend,
  isEmpty
};
const { setupTestId } = useDataTestIdProp();
const __default__ = {
  name: "MultipleInputs",
  components: { SingleInput },
  inheritAttrs: false
};
const _sfc_main = /* @__PURE__ */ Object.assign(__default__, {
  props: {
    ...baseProps,
    ...types
  },
  emits,
  setup(__props) {
    const props = __props;
    const $style = useCssModule();
    const { formatTestId } = setupTestId(props);
    const { v2Listeners } = useListeners(["change"]);
    const { computedItems } = getItemsWithDefaultKeys(props);
    const fieldsetLegend = ref(null);
    const initialValue = props.checked || props.modelValue || props.value;
    const currentValue = ref(initialValue || []);
    const directionClass = computed(() => ({
      [$style.isDirectionRow]: props.directionRow
    }));
    function isDisabled(item) {
      return props.disabled || item.disabled;
    }
    function getDataTestId(item) {
      return (item == null ? void 0 : item.dataTestid) || props.dataTestid;
    }
    const legendIsEmpty = computed(() => {
      var _a;
      return !!((_a = fieldsetLegend.value) == null ? void 0 : _a.textContent);
    });
    return { __sfc: true, setupTestId, props, $style, formatTestId, v2Listeners, computedItems, fieldsetLegend, initialValue, currentValue, directionClass, isDisabled, getDataTestId, legendIsEmpty, SingleInput, changeEvent };
  }
});
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _c("fieldset", { class: _setup.$style.BaseOptionFieldset, attrs: { "disabled": _vm.disabled, "data-testid": _setup.formatTestId("fieldset") } }, [_c("legend", { ref: "fieldsetLegend", class: [_setup.$style.BaseOptionFieldsetLegend, !_setup.legendIsEmpty && _setup.$style.isEmpty], attrs: { "data-testid": _setup.formatTestId("FieldsetLegend") } }, [_vm._t("default")], 2), _c("div", { class: [_setup.$style.container, _setup.directionClass], attrs: { "data-testid": _setup.formatTestId("fieldsetContainer") } }, _vm._l(_setup.computedItems, function(item) {
    return _c(_setup.SingleInput, _vm._g(_vm._b({ key: `key-${item.value}-${_setup.currentValue}`, attrs: { "type": _vm.type, "name": _vm.name, "value": item.value, "label-first": _vm.labelFirst, "disabled": _setup.isDisabled(item), "data-testid": _setup.getDataTestId(item) }, on: _vm._d({}, [_setup.changeEvent, ($event) => _vm.$emit(_setup.changeEvent, $event)]), model: { value: _setup.currentValue, callback: function($$v) {
      _setup.currentValue = $$v;
    }, expression: "currentValue" } }, "SingleInput", _vm.$attrs, false), _setup.v2Listeners), [_vm._v(" " + _vm._s(item.text) + " ")]);
  }), 1)]);
};
var _sfc_staticRenderFns = [];
const __cssModules = {
  "$style": style0
};
function _sfc_injectStyles(ctx) {
  for (var key in __cssModules) {
    this[key] = __cssModules[key];
  }
}
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  _sfc_injectStyles
);
const MultipleInputs = __component__.exports;
export {
  MultipleInputs as default
};
